import { render, staticRenderFns } from "./AxFilesystemNodeRename.vue?vue&type=template&id=22a1dbb0&"
import script from "./AxFilesystemNodeRename.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodeRename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports